import {
  NAVIGATE_TO_SHOW,
  NAVIGATE_TO_DETAILS,
  NAVIGATE_TO_CARD,
} from "./actions"

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case NAVIGATE_TO_SHOW:
      return {
        ...state,
        ...payload,
        view: 'show'
      }
    case NAVIGATE_TO_DETAILS:
      return {
        ...state,
        view: 'details'
      }
    case NAVIGATE_TO_CARD:
      return {
        ...state,
        checkout: payload.checkout,
        view: 'card'
      }
    default:
      return { ...state }
    }
}

export const propsToState = (props) => {
  return {
    permissions: {
      showBilling: props.permissions?.includes('organization-billing:show'),
      editBilling: props.permissions?.includes('organization-billing:edit'),
      showSubscription: props.permissions?.includes('organization-subscription:show'),
      editSubscription: props.permissions?.includes('organization-subscription:edit'),
    },
    billable: props.billingDetails?.billable || {},
    invoice: props.billingDetails?.invoice || {},
    address: props.billingDetails?.billable?.address || {},
    checkout: {} as any,
    paths: props.paths || {},
    view: 'show'
  }
}